import React from "react";
import { Button, FormControl, InputLabel, ListItem, ListItemText, MenuItem, Paper, Select, Stack, Typography } from "@mui/material";
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import Service from "../../../../util/Service";
import { copyStringToClipboard, prettify } from "../../../../util/Utilitarios";

export default function CamelCartaoCode(props) {
    const {action, setCode} = props;
    const [open, setOpen] = React.useState(false);
    const [projetos, setProjetos] = React.useState();
    const [kanbans, setKanbans] = React.useState([]);
    const [coluna, setColuna] = React.useState('');
    const [kanban, setKanban] = React.useState();
    const [esforco, setEsforco]= React.useState();
    const [descricao, setDescricao]= React.useState('');

    React.useEffect(() => {
        if (open) {
            buscaProjetos();
        }
    }, [open])

    function buscaProjetos() {
        Service.GET('/api/projeto/buscaTodos').then(r => setProjetos(r));
    }
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    function handleItemClick(e, id) {
        console.log(id);
        if (id.includes('projeto')) {
            buscaKanban(id.split(":")[1])
        } else {
            const card = kanbans.find(c => c.id === id.split(":")[1])
            setKanban(card);
        }
    }
    function buscaKabanDoProjeto(id) {
        const itens = kanbans.filter(k => k.idProjeto === id)
        return itens;
    }
    function buscaKanban(id) {
        const itens = buscaKabanDoProjeto(id);
        if (!itens || itens.length === 0) {
            console.log("????")
            Service.GET("/api/projeto/kanbans/" + id).then(r => {

                if (r && r.length > 0) {
                    const arr = [...kanbans];
                    setKanbans(arr.concat(r));
                }
            });
        }
    }
    function disable(){
        if( kanban && coluna.length > 0) return false;
        return true;
    }

    function getValue(){
        var txt = '';
        if(kanban){
            const p = projetos.find(prj => prj.id === kanban.idProjeto)
            txt = p.nome;
            txt +="/"+kanban.nome
        }
        return txt;
    }
    function handleCopyClipboard(clipboard){
        const dado = {
            arquivo: 'camel-js-inclue-cards.js',
            idKanban: kanban.id,
            idColuna: coluna, 
            esforco:esforco,
            descricao: descricao,
        }
        console.log( dado);

        Service.POST("/api/security/model/camelMongoQuery", dado).then(r => {
            if (r.success) {
                console.log( r );
                const jsonString = prettify(r.code);
                if( clipboard){
                    copyStringToClipboard(jsonString);
                }else{
                    setCode( jsonString)
                }
                handleClose();
                if(action)action();
            } else {
                alert(r.msg)
            }
        })
    }
    return (
        <React.Fragment>
            <ListItem sx={{ cursor: 'pointer' }} onClick={handleClickOpen}>
                <ListItemText
                    primary="Cartão Task"
                    secondary={
                        <React.Fragment>
                            <Typography
                                component="span"
                                variant="body2"
                                sx={{ color: 'text.primary', display: 'inline' }}
                            >
                                Cartão
                            </Typography>
                            {" — Gerar codigo de criação"}
                        </React.Fragment>
                    }
                />
            </ListItem>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Projeto/Kanban</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Escolha qual quadro será aberto o cartão
                    </DialogContentText>
                    <Stack direction="row" spacing={2}>
                        <Box sx={{ minHeight: 352, width: 480, maxWidth: 580, background:'yellow' }}>
                            <SimpleTreeView onItemClick={handleItemClick}>
                                {projetos && projetos.map((row) => {
                                    const kbs = buscaKabanDoProjeto(row.id);
                                    return (
                                        <TreeItem key={row.id} itemId={"projeto:" + row.id} label={row.nome}>
                                            {kbs && kbs.length > 0 && kbs.map((k) => (
                                                <TreeItem key={k.id} itemId={"kanban:" + k.id} label={k.nome} />
                                            ))}

                                            {!kbs || kbs.length === 0 &&
                                                <TreeItem itemId="grid-pro" label="buscando..." />}
                                            {/* <TreeItem itemId="grid-premium" label="@mui/x-data-grid-premium" /> */}
                                        </TreeItem>
                                    )
                                }
                                )}
                            </SimpleTreeView>
                        </Box>
                        <Paper sx={{ minWidth: 320, p:2}}>
                            <Stack spacing={2}>
                                <TextField size="small" label="Quadro" value={getValue()}
                                    slotProps={{
                                        input: {
                                            readOnly: true,
                                        },
                                    }}
                                />
                                <TextField size="small" label="Esforço em horas" type="number" value={esforco} onChange={(e)=>setEsforco(e.target.value)}/>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="demo-simple-select-label">Coluna</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={coluna}
                                        label="Coluna"
                                        onChange={(e) => setColuna(e.target.value)}
                                    >
                                        {kanban && kanban.colunas.map((row) => (
                                            <MenuItem key={row.id} value={row.id}>{row.nome}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <TextField size="small"
                                    id="outlined-multiline-static"
                                    label="Descrição"
                                    multiline
                                    rows={4}
                                    defaultValue="Default Value"
                                    value={descricao} onChange={(e)=> setDescricao(e.target.value)}
                                />
                            </Stack>

                        </Paper>

                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button disabled={disable()} onClick={() =>handleCopyClipboard(true)}>
                        Area transfência
                    </Button>
                    <Button disabled={disable()} onClick={() =>handleCopyClipboard(false)} >
                        Copiar Código
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}